(ns ui.editors.card.associations.sub
  (:require
   [re-frame.core :as rf]
   [ui.editors.card.sub :as common-sub]
   [common.localization :as loc]
   [ui.state.session.sub :as session-sub]
   [ui.editors.card.associations.model :as model]

   ;; TODO remove this import later because it uses frontend.session
   [frontend.view.field-templates :as templates]
   [common.schema.registry :as registry]))

(rf/reg-sub
 ::tables
 :<- [::common-sub/card-config]
 (fn [card-config]
   (:tables card-config)))

(rf/reg-sub
 ::table-count
 :<- [::tables]
 (fn [tables]
   (count tables)))

(rf/reg-sub
 ::selected-entity-types
 :<- [::tables]
 (fn [tables]
   (->> tables
        (mapv :entity-type))))

(rf/reg-sub
 ::associated-entity-type-options
 :<- [::selected-entity-types]
 (fn [selected-entity-types]
   (let [selected-entity-types-set (set selected-entity-types)]
     (->> model/all-associated-entity-type-options
          (remove (fn [{:keys [value]}]
                    (contains? selected-entity-types-set value)))
          (vec)))))

(rf/reg-sub
 ::table-config
 :<- [::tables]
 (fn [tables [_ table-index]]
   (nth tables table-index)))

(rf/reg-sub
 ::table-title
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])])
 (fn [[table-config]]
   (:title table-config)))

(rf/reg-sub
 ::table-entity-type
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])])
 (fn [[table-config]]
   (:entity-type table-config)))

(rf/reg-sub
 ::table-group-by-association-type?
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])])
 (fn [[table-config]]
   (:group-by-association-type? table-config)))

(rf/reg-sub
 ::table-sort-model
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])])
 (fn [[table-config]]
   (:sort-model table-config)))

;; TODO: Modify next two if allow users to add multiple sort fields in the editor
(rf/reg-sub
 ::table-sort-by-field
 (fn [[_ table-index]]
   [(rf/subscribe [::table-sort-model table-index])])
 (fn [[sort-model]]
   (some-> sort-model
           first
           :field)))

(rf/reg-sub
 ::table-sort-direction
 (fn [[_ table-index]]
   [(rf/subscribe [::table-sort-model table-index])])
 (fn [[sort-model]]
   (some-> sort-model
           first
           :sort-direction)))

(rf/reg-sub
 ::table-entity-peek-config
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])])
 (fn [[table-config]]
   (:entity-peek table-config)))

(rf/reg-sub
 ::table-columns
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[table-config tenant-schema]]
   (->> table-config
        :columns
        (mapv
         (fn [col-config]
           (let [field (:field col-config)
                 field-schema (registry/get-field-schema tenant-schema field)
                 label (loc/field-name field field-schema)]
             (assoc col-config
                    :label label
                    :value field)))))))
(rf/reg-sub
 ::selected-table-fields
 (fn [[_ table-index]]
   [(rf/subscribe [::table-columns table-index])])
 (fn [[table-columns]]
   (->> table-columns
        (mapv :field))))

(rf/reg-sub
 ::selected-table-columns
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[table-config tenant-schema]]
   (let [table-entity-type (:entity-type table-config)]
     (->> table-config
          :columns
          (mapv
           (fn [{:keys [field]}]
             (let [field-schema (registry/get-field-schema tenant-schema field)
                   label (case field
                           :association-type (loc/tr :association-dash-type)
                           :association-comment (loc/tr :association-dash-comment)
                           (str (loc/tr table-entity-type)
                                " - "
                                (loc/field-name field field-schema)))]
               {:value field
                :label label})))))))

;; TODO and FIXME this may not work correctly in every scenario
;; Maybe create some function that can be used like "give me fields of entity type X that user can display in the cards"
(rf/reg-sub
 ::table-entity-field-options
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[table-config tenant-schema] _]
   (let [entity-type (:entity-type table-config)
         schema (templates/entity-type-template
                 {:entity-type     entity-type
                  :selected-fields []
                  :tenant-schema   tenant-schema
                  :account         nil
                  :role            nil
                  :remove-fields   #{}
                  :overrides       nil})
         options (->> schema
                      (remove (fn [[_ field-schema]]
                                (:field/secondary-field? field-schema)))
                      (mapv (fn [[field field-schema]]
                              (let [label (loc/field-name field field-schema)]
                                {:value field
                                 :label label})))
                      (sort-by :label)
                      (vec))]
     options)))

(rf/reg-sub
 ::entity-peek-visible-fields
 (fn [[_ table-index]]
   [(rf/subscribe [::table-config table-index])
    (rf/subscribe [::session-sub/tenant-schema])])
 (fn [[table-config tenant-schema]]
   (->> table-config
        :entity-peek
        :visible-fields
        (mapv (fn [field]
                (let [field-schema (registry/get-field-schema tenant-schema field)
                      label (loc/field-name field field-schema)]
                  {:value field
                   :label label}))))))

(rf/reg-sub
 ::entity-peek-visible-fields-strategy
 (fn [[_ table-index]]
   [(rf/subscribe [::table-entity-peek-config table-index])])
 (fn [[entity-peek-config]]
   (:visible-fields-strategy entity-peek-config)))

(rf/reg-sub
 ::entity-peek-field-options
 (fn [[_ table-index]]
   [(rf/subscribe [::table-entity-peek-config table-index])
    (rf/subscribe [::table-entity-field-options table-index])])
 (fn [[entity-peek-config all-field-options]]
   (let [visible-fields-set (-> entity-peek-config
                                :visible-fields
                                (set))]
     (->> all-field-options
          (filterv (fn [{:keys [value]}]
                     (not (contains? visible-fields-set value))))))))

(rf/reg-sub
 ::table-column-available-options
 (fn [[_ table-index]]
   [(rf/subscribe [::common-sub/entity-type])
    (rf/subscribe  [::selected-table-fields table-index])
    (rf/subscribe [::table-entity-field-options table-index])
    (rf/subscribe [::table-entity-type table-index])])
 (fn [[card-entity-type selected-column-fields entity-column-options table-entity-type]]
   (let [selected-fields-set (set selected-column-fields)

         association-column-options
         [{:value :association-type
           :label (loc/tr :association-dash-type)}
          {:value :association-comment
           :label (loc/tr :association-dash-comment)}]

         entity-column-options
         (->> entity-column-options
              (mapv (fn [{:keys [value label]}]
                      {:value value
                       :label (str (loc/tr table-entity-type) " - " label)})))

         all-options (concat association-column-options
                             entity-column-options)

         available-options (->> all-options
                                (remove (fn [{:keys [value]}]
                                          (contains? selected-fields-set value)))
                                (vec))]
     available-options)))

